import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import Read from "../../../../styles/img/read.png"
import Act from "../../../../styles/img/act.png"
import Earn from "../../../../styles/img/earn-incentive.png"
import { UiHowSectionWorkCol, UiHowSectionWorkColHeading } from "./UiHowSectionWorkCol"

export default function UiHowCampaignsWork(props) {


    return (
        <>
            <UiSingleRow>
                <UiCol lg="2"><UiHowSectionWorkColHeading title={props.title} /></UiCol>
                <UiCol lg="10">
                    <UiSingleRow>
                        <UiHowSectionWorkCol heading="Read" image={Read} content="Make sure you fully understand the campaign rules." />
                        <UiHowSectionWorkCol heading="Act" image={Act} content="Focus you activities immediately to maximise your chances." />
                        <UiHowSectionWorkCol heading="Earn" image={Earn} content="Keep a check on your performance. Your efforts may bring you big rewards." />
                    </UiSingleRow>
                </UiCol>
            </UiSingleRow>
        </>
    )
}


export function UiHowItWorks(props) {

    const HowItWorksItems = props.HowItWorksItems;

    return (
        <>
            <UiSingleRow>
                <UiCol lg="2"><UiHowSectionWorkColHeading title={props.title} /></UiCol>
                <UiCol lg="10">
                    <UiSingleRow>
                        {
                            HowItWorksItems.map((item, index) =>
                                <>
                                    <UiHowSectionWorkCol key={index} heading={item.heading} image={item.icon} content={item.description} />
                                </>
                            )
                        }
                    </UiSingleRow>
                </UiCol>
            </UiSingleRow>
        </>
    )
}